export const showOverlay = () => {
    //@ts-ignore
    const overlay = success_overlay as HTMLElement;
    overlay.removeAttribute('hidden');
}